/** Language preference cookie — synced client-side and via cookies-ultrum PHP. */
const COOKIE_NAME = 'tg_lang_preference';
const MAX_AGE_SEC = 365 * 24 * 60 * 60;

export function langFromPath(pathname) {
  return pathname === '/en' || pathname.startsWith('/en/') ? 'en' : 'fr';
}

export function getLangPreference() {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(new RegExp(`(?:^|; )${COOKIE_NAME}=([^;]*)`));
  const val = match ? decodeURIComponent(match[1]) : null;
  return val === 'en' || val === 'fr' ? val : null;
}

export function setLangPreference(lang) {
  if (lang !== 'fr' && lang !== 'en') return;
  if (typeof document !== 'undefined') {
    const secure = typeof window !== 'undefined' && window.location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = `${COOKIE_NAME}=${lang}; max-age=${MAX_AGE_SEC}; path=/; SameSite=Lax${secure}`;
  }
  if (typeof fetch !== 'undefined') {
    const base = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
    fetch(`${base}/cookies-ultrum/set-lang.php?lang=${encodeURIComponent(lang)}`, {
      credentials: 'same-origin',
      keepalive: true,
    }).catch(() => {});
  }
}
